import { useMemo } from "react";
import { useVisible } from "../../../../../utils/hooks/useVisible";
import Modal from "./Modal";

export const useRecalculateTimeSheetModal = ({
    onSuccess,
    onFailure,
}) => {
    const { visible, selected: data, open, close } = useVisible();

    const modal = useMemo(() => {
        if (!visible) {
            return null;
        }
        return (
            <Modal
                visible={visible}
                close={close}
                data={data}
                onSuccess={onSuccess}
                onFailure={onFailure}
            />
        );
    }, [visible, close, data, onSuccess, onFailure]);

    return [open, modal];
}
